export default __webpack_public_path__ + "static/footer-badge-1-97b40c20f19c1fb6dddaf8059cb51598.svg";